<template>
  <div class="ToolTip">
    <div class="ToolTip__icon">?</div>
    <div class="ToolTip__content" :data-from="from">
      <p v-html="content" />
    </div>
  </div>
</template>

<script>
  export default {
    props: ['content', 'from']
  }
</script>

<style lang="scss">
  @import "~@sass/components/_ToolTip.scss";
</style>
